import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import useContryCurrencyHook from "../../../common/hooks/useCountryCurrencyList.ts";
import { ContractModel } from "../Contract.types.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";

export interface CurrencyFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    /** Suppresses the field's help icon, for a view where the same field is shown twice. */
    hideToolTip?: boolean;
    currencyCode: string | undefined;
    onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>;
    readOnly: boolean;
    isDisabled: boolean;
    required: boolean;
    isLoading: boolean;
    errorText?: string;
}

function CurrencyField(props: CurrencyFieldProps) {
    const { translateString } = useTranslation();
    const { getCurrenciesAsNames } = useContryCurrencyHook();

    const currencyOptions = React.useMemo(() => getCurrenciesAsNames(), [getCurrenciesAsNames]);

    return (
        <DotLegalSelect
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            options={currencyOptions}
            onChange={
                props.readOnly
                    ? () => {}
                    : (value) =>
                          props.onChange((c) => {
                              c.currencyCode = value ? value : undefined;
                          })
            }
            label={translateString("currency")}
            selectedItem={props.currencyCode}
            disabled={props.isDisabled}
            disableClearable={props.required}
            noOptionsLabel={translateString("noOptions")}
            toolTipText={props.hideToolTip ? undefined : translateString("contractCurrencyTooltip")}
            isLoading={props.isLoading}
            errorText={props.errorText}
        />
    );
}

export default CurrencyField;
